import React, { useEffect, useState } from "react";
import { FormGroup } from "react-bootstrap";
import WidgetsListItem from "./WidgetListItem";

const WidgetsList = (
    {
        list,
        onEdit,
        onDelete,
    }
) => {
    const [widgetsList, setWidgetLists] = useState([]);

    useEffect(() => {
        setWidgetLists(list || []);
    }, [list]);

    return (
        <FormGroup>
            {widgetsList?.map((widget) => (
                <WidgetsListItem
                    key={widget.id}
                    widget={widget}
                    onEdit={onEdit}
                    onDelete={onDelete}
                />
            ))}
        </FormGroup>
    );
};

export default WidgetsList;
